import axios from 'axios'

class DocumentoProcessoDigitalApiClient {
	constructor(urlBuilder) {
		this.urlBuilder = urlBuilder
	}

	async assinarDocumentoEletronicamente(idDocumento) {
		return await axios.post(this.urlBuilder.processoDigital.getUrlAssinarDocumentoEletronicamente(idDocumento))
	}
	async assinarDocumentoDigitalmente(idDocumento) {
		return await axios.post(this.urlBuilder.processoDigital.getUrlAssinarDocumentoDigitalmente(idDocumento))
	}

	async validarDocumentoAssinado(idDocumento) {
		return await axios.post(this.urlBuilder.processoDigital.getUrlValidarDocumentoAssinado(idDocumento))
	}

	async juntarLoteDocumentosProcessoDigital(payload) {
		return await axios.put(this.urlBuilder.processoDigital.getUrlJuntarDocumentoLote(payload.idEntidadePai), {
			idsDocumentos: payload.idsDocumentos,
		})
	}
	async buscarDocumentoPorId(idDocumento) {
		return await axios.get(this.urlBuilder.processoDigital.getUrlbuscarDocumentoPorId(idDocumento))
	}
}

export default DocumentoProcessoDigitalApiClient
